import React from 'react';
import { IS_PHYSICAL_OPTION } from '../../../../shared/leave/constants';
import { DefaultDropdownProps, EnumDropdown } from 'framework/form';
import { Box } from '@mui/material';

const SignatureOptionDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Box sx={{ '@media (min-width: 900px)': { '& .form-control': { maxWidth: '50% !important' } } }}>
      <EnumDropdown options={IS_PHYSICAL_OPTION} placeholder="" {...props} />
    </Box>
  );
};

export default SignatureOptionDropdown;
